import React from "react";
import { Redirect } from "react-router-dom";
import { Input, Segment } from "semantic-ui-react";
import styled from "styled-components";
import BaseComponent from "./BaseComponent";
import AppHeaderSmall from "./common/AppHeaderSmall";
import Footer from "./common/Footer";
import MainContentWrapper from "./common/MainContentWrapper";
import PeopleSearchResult from "./common/PeopleSearchResult";
import SFCookieConsent from "./common/SFCookieConsent";
import SiteWrapper from "./common/SiteWrapper";
import TabBar from "./common/TabBar";
import ErrorDisplay from "./ErrorDisplay";

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
`;

const SearchInput = styled(Input)`
  color: #1cbff2;
`;

class AddPublisher extends BaseComponent {
  constructor() {
    super();
    this.state = {
      showActivityIndicator: false,
      searchString: "",
      searchResults: null,
    };

    this.searchPublishers = this.searchPublishers.bind(this);
  }

  async searchPublishers(searchString) {
    if (!(await this.checkLogin())) {
      return;
    }
    this.errorManager.reset();

    if (searchString.trim().length < 3) {
      this.setState({ searchResults: null });
      return;
    }
    const response = await this.safeFunApi.searchPublishers(searchString);
    console.log(response.data);
    this.setState({ searchResults: response.data });
  }

  render() {
    return (
      <SiteWrapper>
        {this.state.redirectPath ? (
          <Redirect
            to={{
              pathname: this.state.redirectPath,
              search: this.state.redirectSearch,
              state: this.state.redirectState,
            }}
          />
        ) : null}

        <AppHeaderSmall title="Add" />
        <MainContentWrapper>
          <TabBar people />
          <Wrapper>
            <SearchInput
              spellcheck={false}
              placeholder="Name, SafeFun ID or email"
              onChange={(e) => {
                this.searchPublishers(e.target.value);
              }}
            />
            {this.state.searchResults && this.state.searchResults.length > 0 ? (
              <Segment
                style={{
                  overflow: "auto",
                  maxHeight: 600,
                  border: "none",
                  backgroundColor: "#F7F7F7",
                  marginTop: 20,
                }}
              >
                {this.state.searchResults.map((result) => (
                  <PeopleSearchResult
                    key={result.sF_ConsumerId}
                    item={result}
                  />
                ))}
              </Segment>
            ) : null}
            {this.errorManager.getErrorCount() > 0 ? (
              <ErrorDisplay errorManager={this.errorManager} />
            ) : null}
          </Wrapper>
        </MainContentWrapper>
        <Footer />
        <SFCookieConsent />
      </SiteWrapper>
    );
  }
}

export default AddPublisher;
